export default __webpack_public_path__ + "static/media/poster-5-NCBI.7ab8f3ef.png";